import React, {Component} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';
import Spinner from '../Spinner';
import {setLocale} from '../../actions/locales/setLocale';
import {getTranslations} from '../../actions/locales/getTranslations';
import {registerLocale} from 'react-datepicker';
import he from 'date-fns/locale/he';
import enUS from 'date-fns/locale/en-US';

registerLocale('he', he);
registerLocale('en', enUS);


function providerLocale(WrappedComponent) {
  return class extends Component {
    state = {
      messages: null
    };

    componentDidMount() {
      if (!this.state.messages) {
        this.updateMessages();
      }
    }

    componentDidUpdate(prevProps) {
      if (prevProps.current !== this.props.current) {
        this.updateMessages();
      }
    }

    updateMessages = () => {
      const {current, getTranslations} = this.props;
      getTranslations(current)
        .then(() => {
          const {translations} = this.props;
          this.setState({messages: translations})
        })
    };

    render() {
      const {
        current,
        setLocale,
        translations,
        loading,
        error,
        errorMessage,
        ...rest
      } = this.props;

      return (loading || !this.state.messages)
        ? <Spinner/>
        : (
          <IntlProvider
            locale={current}
            messages={this.state.messages}
            defaultRichTextElements={{
              b: (chunks) => <b>{chunks}</b>,
              br: <br/>,
            }}
          >
            <WrappedComponent {...rest}/>
          </IntlProvider>
        );
    }
  }
}

const mapStateToProps = ({
                           locales: {
                             current,
                             translations,
                             loading,
                             error,
                             errorMessage
                           }
                         }) => {
  return {
    current,
    translations,
    loading,
    error,
    errorMessage,
  }
};

export default compose(
  connect(
    mapStateToProps,
    {setLocale, getTranslations}
  ),
  providerLocale
);

